var render, staticRenderFns
import script from "./OrdersHourlyChart.vue?vue&type=script&lang=js&"
export * from "./OrdersHourlyChart.vue?vue&type=script&lang=js&"
import style0 from "./OrdersHourlyChart.vue?vue&type=style&index=0&id=5b9f115c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f115c",
  null
  
)

export default component.exports